module.exports = __webpack_public_path__ + "img/gerry.47b2248.webp";